/**
 * Created by Viacheslav Stepanian on 07.09.2026
 */

const SingleProductOfferPrefabWindow = Prefab.createWindow((offer) => offer.bundle, "offer_prefab_json");
